import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Button,
  Card,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Row,
  Table
} from 'reactstrap';

import styles from './style.module.scss';

import InfoIcon from '../../../assets/images/icons/info.svg';
import MoreIcon from '../../../assets/images/icons/more.svg';

import Environment from '../../../environment/Environment';
import { UpdateEditRestriction } from '../../../store/action-restriction/actions';
import { GetPlanId, IsNegative, NumberWithCommas, OneDecimalPlace } from '../../../helpers/Helpers';
import {
  grandTotal, horizontalFutureTotal, horizontalPlanUnitTotal,
  horizontalTotal, remainingHorizontalPlanUnitTotal,
  remainingHorizontalTotal, remainingVerticalTotal,
  verticalTotal
} from '../../SKULevelSalesPlan/planning-table/helper';


import InitialMessage from '../../../components/Common/initial-message/initial-message';
import NoDataFound from '../../../components/Common/no-data-found/no-data-found';
import SuccessModal from '../../../components/Common/Modals/SuccessModal';
import Pagination from '../../../components/Common/pagination/pagination';
import Tooltip from '../../../components/Common/tooltip/tooltip';
import PageLoader from '../../../components/Common/loader/PageLoader';
import ActionCard from '../../../components/Footer/ActionCard';

import { IMeasureVisibilityPayload } from '../../../interfaces/common.interface';
import {
  ISKULevelPlanningEditAllColumn,
  ISKULevelPlanningEditAllData
} from '../../../interfaces/sku-level-rolling-plan-edit-all.interface';
import {
  DownloadSkuLevelTemplate,
  DownloadSKULevelEditAllTemplate,
  UpdateMeasureVisibility
} from '../../../api-services/common.api';
import {
  FreezePlan,
  GetSKULevelRollingPlanEditAllData,
  SaveSKULevelWeekData,
  ImportTemplate,
} from '../../../api-services/sku-level-rolling-plan.api';

interface OwnProps {
  history: any;
  isCallRequired: boolean;
  onLoadEnd: () => void;
  onUpdateStart: () => void;
  onUpdateEnd: () => void;
}

interface StateProps {
  history: any;
  isAllowed: boolean;
  filterData: any;
}

interface DispatchProps {
  UpdateEditRestriction: (isAllowed: boolean) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  isAutoLoad:boolean;
  isLoading: boolean;
  originalDataSource: ISKULevelPlanningEditAllData;
  dataSource: ISKULevelPlanningEditAllData;
  distributionMode: string;
  isColumnExpanded: boolean;
  isModalOpened: boolean;
  itemsCount: number;
  itemsPerPage: number;
  currentPage: number;
  totalPages: number;
  sortKey: string;
  sortDirection: string;
  isVisibilityMenuOpened: boolean;
  isMoreMenuOpened: boolean;
  isDownloadMenu: boolean;
  measureVisibilityList: any[];
  drag: {
    iniMouse: number;
    iniSize: number;
  };
  width: any;
  initializeList: {
    label: string;
    value: string;
  }[];
  isEditRestrictionAllowed: boolean;
  selectedInitialize: string;
  ratioList: string[];
  selectedRatio: string;
  referenceSKU: number;
  draggedPosition: number;
  selectedMeasure: string;
}

const measureList = [
  { id: 'qty_quota', value: 'Plan / Quota U' },
  { id: 'val_quota', value: 'Plan / Quota Sales $' },
  { id: 'plan_asp', value: 'Plan ASP $' },
  { id: 'margin_pct', value: 'Margin %' },
  { id: 'margin', value: 'Margin $' },
];

class PlanningTable extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    const fromRollingPlan = this.props.history.location.state?.fromRollingPlan ?? false;

    this.state = {
      isAutoLoad:!fromRollingPlan,
      isLoading: true,
      originalDataSource: { columns: [], rows: [] },
      dataSource: { columns: [], rows: [] },
      distributionMode: 'Fixed SKU',
      isColumnExpanded: true,
      isModalOpened: false,
      itemsCount: 0,
      itemsPerPage: Environment.ITEMS_PER_PAGE,
      currentPage: 1,
      totalPages: 0,
      sortKey: '',
      sortDirection: 'asc',
      isMoreMenuOpened: false,
      isDownloadMenu: false,
      isVisibilityMenuOpened: false,
      measureVisibilityList: [],
      drag: {
        iniMouse: 0,
        iniSize: 0
      },
      width: 0,
      initializeList: [
        { label: 'Copy LY', value: 'LY' },
        { label: 'Copy LQ', value: 'LQ' }
      ],
      isEditRestrictionAllowed: false,
      selectedInitialize: '',
      ratioList: ['LY', 'LQ', 'RECENT', 'FORECAST'],
      selectedRatio: 'RECENT',
      referenceSKU: 0,
      draggedPosition: 0,
      selectedMeasure: 'qty_quota',
    };

    this.toggleVisibilityMenu = this.toggleVisibilityMenu.bind(this);
    this.toggleMoreMenu = this.toggleMoreMenu.bind(this);
    this.toggleDownloadMenu = this.toggleDownloadMenu.bind(this);
  }

  toggleMoreMenu(): void {
    this.setState((prevState) => ({
      isMoreMenuOpened: !prevState.isMoreMenuOpened
    }));
  }

  componentDidMount(): void {
    //this.getSKULevelRollingPlanEditAllData();
    const { state } = this.props.history.location;
    const fromRollingPlan = state?.fromRollingPlan ?? false;  // Read flag
    if (fromRollingPlan) {
      this.setState({ 
        isAutoLoad: false,
        isLoading: true, //Explicitly set isAutoLoad to false,
      }); 
      this.getSKULevelRollingPlanEditAllData(); // Load data ONLY if coming from Rolling Plan
    } else {
      this.setState({ isLoading: false });
      this.props.onLoadEnd();
    }
    this.setState({
      width: document.getElementById('sku-level-rolling-plan-edit-all-table')?.offsetWidth || 0
    });
  }

  componentDidUpdate(prevProps, prevState): void {
    if (!prevProps.isCallRequired && this.props.isCallRequired) {
      this.setState({
        isLoading: false
      }, () => {
        this.getSKULevelRollingPlanEditAllData();
      });
    }
  }

  importTemplate = (event): void => {
    let formData = new FormData();
    formData.append('file', event.target['files'][0], event.target['files'][0].name);

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    this.props.onUpdateStart();

    ImportTemplate(formData, params)
      .then(() => {
        this.props.onUpdateEnd();
      });
  };

  downloadSKULevelFreezePlan(type: string): void {
    this.setState({ isLoading: true });

    const params = {
      type,
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    DownloadSKULevelEditAllTemplate(params).then((response) => {
      let filename = '';
      switch (type) {
        case 'RollingPlanSKULevelFreeze':
          filename = 'sku_level_rolling_edit_all_freeze.xlsx';
          break;
      }
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        this.setState({ isLoading: false });
      });
    });
  }

  downloadSkuLevelSalesPlan(downloadType: string): void {
    this.setState({ isLoading: true });

    const params = {
      downloadPlan: 'RPSKU',
      downloadType,
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    DownloadSkuLevelTemplate(params).then((response) => {
      let filename = '';
      switch (downloadType) {
        case 'UNIT':
          filename = 'SKU-Level-Rolling-Plan-Edit-All-UNIT.xlsx';
          break;
        case 'VALUE':
          filename = 'SKU-Level-Rolling-Plan-Edit-All-VALUE.xlsx';
          break;

      }
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        this.setState({ isLoading: false });
      });
    });
  }

  getSKULevelRollingPlanEditAllData(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
    };

    GetSKULevelRollingPlanEditAllData(params)
      .then((res: ISKULevelPlanningEditAllData) => {
        let { columns } = res;
        const newObject = {
          dT: 'varchar',
          isV: true,
          prevCheck: true,
          n: 'measure',
          dN: 'Measure',
          w: [],
          position: 0,
          width: 0,
          value: '',
          condition: '=',
        };
        columns.splice(columns.length - 1, 0, newObject);
        columns = columns.map(col => ({ ...col, w: !!col.w ? col.w : [] }));

        this.setState({
          originalDataSource: {
            ...res,
            columns: columns.map((col) => ({
              ...col,
              prevCheck: col.isV,
              w: col.w.map((w) => ({ ...w, value: '', condition: '=' }))
            }))
          },isAutoLoad:false,
        }, () => {
          this.dataInit();
          this.props.onLoadEnd();
        });

        this.props.UpdateEditRestriction(false);
      });
  }

  dataInit(isWeek?: boolean): void {
    let { columns, rows } = this.state.originalDataSource;

    rows = rows.map((row) => ({
      ...row,
      p: { ...row.p, isE: false },
      w: row.w.map((w) => {
        const value = w.rmsr.find((m) => m.n === this.state.selectedMeasure)?.v;
        const weekValue = this.state.selectedMeasure === 'margin_pct' ? OneDecimalPlace(value) : Math.round(value);
        return {
          ...w,
          isEdited: false,
          value: weekValue,
          oldValue: weekValue,
        };
      })
    })).map((row) => ({
      ...row,
      p: { ...row.p, isE: false },
      w: row.w.map((w, wIdx: number) => {
        let total = 0;

        if (this.state.distributionMode === 'Fixed SKU') {
          total = horizontalTotal(row, false);
        } else {
          total = verticalTotal(rows, wIdx, false);
        }

        const ratio = w.value !== 0 ? (w.value / total) : 0;

        return {
          ...w,
          ratio,
          oldRatio: ratio,
          rmsr: w.rmsr.map((rmsr) => {
            const value = rmsr.dT === 'percentage' ? OneDecimalPlace(rmsr.v) : Math.round(rmsr.v);
            return {
              ...rmsr,
              v: value,
              oldV: value,
            };
          }),
        };
      })
    }));

    columns.sort((x, y) => x.position - y.position);
    rows.forEach((row) => {
      row.p.cmsr.sort((x, y) => x.position - y.position);
    });

    const filteredColumnList = columns.filter((measure) => !!measure.value);
    let filteredWeekColumnList: any[] = [];
    columns.forEach(col => {
      col.w.forEach((w) => {
        if (!!w.value) {
          filteredWeekColumnList.push(w);
        }
      });
    });

    if (!isWeek) {
      filteredColumnList.forEach((data) => {
        rows = rows.filter((item) => {
          const idx = item.p.cmsr.findIndex((cmsr) => cmsr.n === data.n);

          if (idx > -1) {
            const matches = typeof item.p.cmsr[idx].v === 'string'
              && item.p.cmsr[idx].v.toLocaleUpperCase().match(data.value.toLocaleUpperCase());
            return typeof item.p.cmsr[idx].v === 'string'
              ? !!(matches && matches.length > 0)
              : (!!data.value
                ? PlanningTable.aggregateFn(data.condition, item.p.cmsr[idx].v, parseFloat(data.value))
                : true);
          }

          return false;
        });
      });
    } else {
      filteredWeekColumnList.forEach(week => {
        rows = rows.filter(row =>
          row.w.some(w => w.n === week.n
            ? PlanningTable.aggregateFn(week.condition, w.value, parseFloat(week.value))
            : false));
      });
    }

    if (!!this.state.sortKey) {
      if (!isWeek) {
        rows.sort((x, y) => {
          const mxIdx = x.p.cmsr.findIndex((m) => m.n === this.state.sortKey);
          const myIdx = y.p.cmsr.findIndex((m) => m.n === this.state.sortKey);

          if (mxIdx > -1 && myIdx > -1) {
            const xField = !!x.p.cmsr[mxIdx].v
              ? (typeof x.p.cmsr[mxIdx].v === 'string' ? x.p.cmsr[mxIdx].v.toLocaleUpperCase() : x.p.cmsr[mxIdx].v)
              : '';
            const yField = !!y.p.cmsr[myIdx].v
              ? (typeof y.p.cmsr[myIdx].v === 'string' ? y.p.cmsr[myIdx].v.toLocaleUpperCase() : y.p.cmsr[myIdx].v)
              : '';

            if (xField === yField) {
              return 0;
            }
            if (this.state.sortDirection === 'asc' && xField < yField) {
              return -1;
            }
            if (this.state.sortDirection === 'desc' && xField > yField) {
              return -1;
            }
          }
          return 1;
        });
      } else {
        rows.sort((x, y) => {
          const mxIdx = x.w.findIndex((w) => w.n === this.state.sortKey);
          const myIdx = y.w.findIndex((w) => w.n === this.state.sortKey);

          let xField = 0, yField = 0;
          if (mxIdx > -1 && myIdx > -1) {
            xField = x.w[mxIdx].value;
            yField = y.w[myIdx].value;
          }

          if (xField === yField) {
            return 0;
          }
          if (this.state.sortDirection === 'asc' && xField < yField) {
            return -1;
          }
          if (this.state.sortDirection === 'desc' && xField > yField) {
            return -1;
          }

          return 1;
        });
      }
    }

    const itemsCount = rows.length;
    rows = rows.slice(this.state.itemsPerPage * (this.state.currentPage - 1), this.state.itemsPerPage * this.state.currentPage);
    this.setState({
      itemsCount,
      totalPages: Math.ceil(this.state.originalDataSource.rows.length / this.state.itemsPerPage),
      dataSource: { columns, rows, },
      isLoading: false,
    }, () => {
      this.getVisibilityList();
    });
  }

  getVisibilityList(): void {
    const measureVisibilityList = this.state.originalDataSource.columns
      .map((measure) => {
        return {
          id: measure.n,
          name: measure.dN,
          isVisible: measure.isV,
          prevCheck: measure.prevCheck === undefined ? measure.isV : measure.prevCheck
        };
      });

    this.setState({ measureVisibilityList });
  }

  checkVisibilitySaveButton(): boolean {
    return this.state.measureVisibilityList
      .every((measure) => measure.isVisible === measure.prevCheck);
  }

  updateMeasureVisibility(): void {
    const payload: IMeasureVisibilityPayload = {
      visibility: this.state.measureVisibilityList
        .map((measure) => {
          return {
            name: measure.name,
            isVisible: measure.isVisible
          };
        })
    };

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    this.setState({ isLoading: true });

    UpdateMeasureVisibility(payload, params)
      .then((res) => {
        if (!!res) {
          this.setState({
            isModalOpened: true
          }, () => {
            this.getSKULevelRollingPlanEditAllData();
          });
        }
      });
  }

  toggleVisibilityMenu(): void {
    this.setState((prevState) => ({
      isVisibilityMenuOpened: !prevState.isVisibilityMenuOpened
    }));
  }

  toggleDownloadMenu(): void {
    this.setState((prevState) => ({
      isDownloadMenu: !prevState.isDownloadMenu
    }));
  }

  freezePlan(): void {
    const payload = {
      rows: this.state.dataSource.rows
        .filter((row) => row.isEdited)
        .map((row) => {
          return {
            p: row.p.c,
            w: row.w.map((w) => {
              return {
                n: w.n,
                m: w.rmsr.filter((rmsr) => rmsr.isC)
                  .map((rmsr) => {
                    return {
                      n: rmsr.n,
                      v: rmsr.v,
                    };
                  })
              };
            }).filter((w) => w.m.length > 0)
          };
        })
    };
    
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
      isWeekEdit:true,
    };

    this.props.onUpdateStart();

    FreezePlan(payload, params)
      .then((res) => {
        if (!!res) {
          this.setState({ isModalOpened: true });
        }

        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
      });
  }

  handlePageChange(pageNumber: number): void {
    this.setState({
      currentPage: pageNumber
    }, () => {
      this.dataInit();
    });
  }

  columnSearchHandler(colIdx: number, value: string, type: 'measure' | 'week', wIdx: number): void {
    if (type === 'measure') {
      this.state.originalDataSource.columns[colIdx].value = value;
    } else {
      const columnIdx = this.state.originalDataSource.columns.findIndex(col => col.n === 'time');
      if (columnIdx > -1) {
        this.state.originalDataSource.columns[columnIdx].w[wIdx].value = value;
      }
    }

    this.setState({
      originalDataSource: this.state.originalDataSource
    }, () => {
      this.dataInit(type === 'week');
    });
  }

  updateAggregateSelect(colIdx: number, value: string, wIdx: number): void {
    this.state.originalDataSource.columns[colIdx].w[wIdx].condition = value;

    this.setState({
      originalDataSource: this.state.originalDataSource
    }, () => {
      this.columnSearchHandler(colIdx, this.state.originalDataSource.columns[colIdx].w[wIdx].value, 'week', wIdx);
    });
  }

  static aggregateFn(symbol: string, a: number, b: number) {
    switch (symbol) {
      case '=':
        return a === b;
      case '<':
        return a < b;
      case '>':
        return a > b;
      case '<=':
        return a <= b;
      case '>=':
        return a >= b;
    }
  };

  doSort(columnName: string, weekName: string): void {
    const data = !weekName
      ? this.state.originalDataSource.columns.find((col) => col.n === columnName)
      : this.state.originalDataSource.columns[this.state.originalDataSource.columns.length - 1].w
        .find((week) => week.n === weekName);

    this.setState({
      sortKey: !!data ? data.n : '',
      sortDirection: data?.n === this.state.sortKey
        ? (this.state.sortDirection === 'asc' ? 'desc' : 'asc')
        : 'asc'
    }, () => {
      this.dataInit(!!weekName);
    });
  }

  resetCalculations(): void {
    this.getSKULevelRollingPlanEditAllData();
  }

  onColumnDrag(position: number): void {
    this.setState({ draggedPosition: position });
  }

  onColumnDrop(position: number): void {
    const draggedPosition = this.state.draggedPosition;
    const droppedPosition = position;

    const draggedIndex = this.state.originalDataSource.columns.findIndex((col) => col.position === draggedPosition);
    const droppedIndex = this.state.originalDataSource.columns.findIndex((col) => col.position === droppedPosition);

    this.state.originalDataSource.columns[draggedIndex].position = droppedPosition;
    this.state.originalDataSource.columns[droppedIndex].position = draggedPosition;

    this.state.originalDataSource.columns.sort((x, y) => x.position - y.position);

    this.state.originalDataSource.rows.forEach((row) => {
      row.p.cmsr[draggedIndex].position = droppedPosition;
      row.p.cmsr[droppedIndex].position = draggedPosition;

      row.p.cmsr.sort((x, y) => x.position - y.position);
    });

    this.dataInit();
  }

  addColumnWidth(colIdx: number, width: number): Object {
    const style = { width: `${width}px` };

    if (colIdx === 0) {
      return { ...style, left: 0 };
    }

    if (colIdx === 1) {
      return {
        ...style,
        left: `${this.state.originalDataSource.columns.length > 0 ? 160 : 0}px`
      };
    }

    return style;
  }

  onUpdateVisibilityCheck(measureIdx: number): void {
    this.state.measureVisibilityList[measureIdx].isVisible =
      !this.state.measureVisibilityList[measureIdx].isVisible;
    this.state.originalDataSource.columns[measureIdx].isV =
      !this.state.originalDataSource.columns[measureIdx].isV;
    this.state.originalDataSource.rows.forEach((row) => {
      row.p.cmsr[measureIdx].isV = !row.p.cmsr[measureIdx].isV;
    });

    this.setState({
      originalDataSource: this.state.originalDataSource,
      measureVisibilityList: this.state.measureVisibilityList
    }, () => {
      this.getVisibilityList();
    });
  }

  onToggleRow(rowIdx: number, productCode: string): void {
    if (this.state.dataSource.rows[rowIdx].p.c === productCode) {
      this.state.dataSource.rows[rowIdx].p.isE = !this.state.dataSource.rows[rowIdx].p.isE;
    }

    this.setState({ dataSource: this.state.dataSource });
  }

  updateMeasureValue(rowIdx: number, weekIdx: number, value: string): void {
    this.state.dataSource.rows[rowIdx].w[weekIdx].value = !!value ? parseFloat(value) : 0;
    // const isEdited = this.state.dataSource.rows[rowIdx].w[weekIdx].value !== this.state.dataSource.rows[rowIdx].w[weekIdx].oldValue;
    this.state.dataSource.rows[rowIdx].isEdited = true;
    this.state.dataSource.rows[rowIdx].w[weekIdx].isEdited = true;

    if (['val_quota', 'qty_quota'].includes(this.state.selectedMeasure)) {
      if (this.state.distributionMode === 'Fixed SKU') {
        const row = this.state.dataSource.rows[rowIdx];
        const weeks = row.w;
        const totalWeeks = weeks.filter(w => !w.isP).length;

        const editedWeeks = weeks.filter(w => w.isEdited);
        const totalEditedWeeks = editedWeeks.length;

        const fixedTotal = horizontalFutureTotal(row, false);

        const totalSumOfEditedCellsNewValue = editedWeeks.reduce((sum, w) => sum + w.value, 0);
        const totalSumOfEditedCellsOldValue = editedWeeks.reduce((sum, w) => sum + w.oldValue, 0);

        const remainingForDist = fixedTotal - totalSumOfEditedCellsNewValue;
        const remainingOfNonEditedCell = fixedTotal - totalSumOfEditedCellsOldValue;

        weeks.filter(w => !w.isEdited && !w.isP)
          .map(w => {
            const ratio = remainingOfNonEditedCell ? (w.oldValue / remainingOfNonEditedCell) : 0;
            w.ratio = ratio;
            w.value = Math.round(ratio * remainingForDist);

            return w;
          });

        /*const actualTotal = horizontalFutureTotal(row, true);
        let uneditedIdx = weeks.findIndex(w => !w.isEdited && !w.isP);

        if (fixedTotal !== actualTotal && uneditedIdx > -1) {
          weeks[uneditedIdx].value = Math.round(weeks[uneditedIdx].value + (fixedTotal - actualTotal));
        }*/

        const actualTotal = horizontalFutureTotal(row, true);
        let uneditedIdx = weeks.findIndex(w => !w.isEdited && !w.isP);

        if (fixedTotal !== actualTotal && uneditedIdx > -1) {
          let remainingDifference = Math.round(fixedTotal - actualTotal);

          while (uneditedIdx > -1 && remainingDifference !== 0) {
            // Calculate the new value for the current unedited week
            const newValue = weeks[uneditedIdx].value + remainingDifference;

            // Ensure value does not go below 0
            if (newValue >= 0) {
              weeks[uneditedIdx].value = newValue;
              remainingDifference = 0; // Adjustment is complete
            } else {
              remainingDifference += weeks[uneditedIdx].value; // Add the current value back to remaining
              weeks[uneditedIdx].value = 0; // Set current value to 0
              // Find the next unedited index
              uneditedIdx = weeks.findIndex((w, idx) => idx > uneditedIdx && !w.isEdited && !w.isP);
            }
          }
        }

        if (totalSumOfEditedCellsNewValue > fixedTotal) {
          row.w[weekIdx].isError = true;
        } else {
          row.w.forEach(w => {
            w.isError = false;
          });
        }

        if (totalWeeks - 1 === totalEditedWeeks && uneditedIdx > -1) {
          weeks[uneditedIdx].isDisabled = true;
        }

        weeks
          .filter(w => !w.isP)
          .map(w => {
            if (this.state.selectedMeasure === 'val_quota') {
              const planValueIdx = w.rmsr.findIndex((rmsr) => rmsr.n === this.state.selectedMeasure);
              const planUnitIdx = w.rmsr.findIndex((rmsr) => rmsr.n === 'qty_quota');
              const planAspIdx = w.rmsr.findIndex((rmsr) => rmsr.n === 'plan_asp');

              w.rmsr[planValueIdx].v = w.value;
              w.rmsr[planUnitIdx].v = w.rmsr[planAspIdx].v !== 0
                ? Math.round(w.rmsr[planValueIdx].v / w.rmsr[planAspIdx].v)
                : 0;
              w.rmsr[planValueIdx].isC = true;
              w.rmsr[planUnitIdx].isC = true;
            } else {
              const mIdx = w.rmsr.findIndex((rmsr) => rmsr.n === this.state.selectedMeasure);
              w.rmsr[mIdx].v = w.value;
              w.rmsr[mIdx].isC = true;
            }

            return w;
          });
      } else {
        const rows = this.state.dataSource.rows;
        const totalSkus = rows.length;

        const fixedTotal = verticalTotal(rows, weekIdx, false);

        let totalEditedWeeks = 0;
        let totalSumOfEditedCellsNewValue = 0;
        let totalSumOfEditedCellsOldValue = 0;

        rows.forEach(row => {
          const week = row.w[weekIdx];
          if (week.isEdited && !week.isP) {
            totalEditedWeeks += 1;
            totalSumOfEditedCellsNewValue += week.value;
            totalSumOfEditedCellsOldValue += week.oldValue;
          }
        });

        const remainingForDist = fixedTotal - totalSumOfEditedCellsNewValue;
        const remainingOfNonEditedCell = fixedTotal - totalSumOfEditedCellsOldValue;

        rows.forEach(row => {
          row.isEdited = true;
          const week = row.w[weekIdx];
          if (!week.isEdited && !week.isP) {
            const ratio = remainingOfNonEditedCell ? (week.oldValue / remainingOfNonEditedCell) : 0;
            week.ratio = ratio;
            row.w[weekIdx].value = Math.round(ratio * remainingForDist);
          }
        });

        /*const actualTotal = verticalTotal(rows, weekIdx, true);
        const uneditedIdx = rows.findIndex(row => !row.w[weekIdx].isEdited && !row.w[weekIdx].isP);

        if (fixedTotal !== actualTotal && uneditedIdx > -1) {
          const week = rows[uneditedIdx].w[weekIdx];
          week.value = Math.round(week.value + (fixedTotal - actualTotal));
        }*/

        const actualTotal = verticalTotal(rows, weekIdx, true);
        let uneditedIdx = rows.findIndex(row => !row.w[weekIdx].isEdited && !row.w[weekIdx].isP);

        if (fixedTotal !== actualTotal && uneditedIdx > -1) {
          let remainingDifference = Math.round(fixedTotal - actualTotal);

          while (uneditedIdx > -1 && remainingDifference !== 0) {
            const week = rows[uneditedIdx].w[weekIdx];

            // Calculate the new value for the current unedited week
            const newValue = week.value + remainingDifference;

            // Ensure value does not go below 0
            if (newValue >= 0) {
              week.value = newValue;
              remainingDifference = 0; // Adjustment is complete
            } else {
              remainingDifference += week.value; // Add the current value back to remaining
              week.value = 0; // Set current value to 0
              // Find the next unedited index for the vertical adjustment
              uneditedIdx = rows.findIndex((row, idx) => idx > uneditedIdx && !row.w[weekIdx].isEdited && !row.w[weekIdx].isP);
            }
          }
        }

        if (totalSumOfEditedCellsNewValue > fixedTotal) {
          rows[rowIdx].w[weekIdx].isError = true;
        } else {
          rows.forEach(row => {
            row.w.forEach(w => {
              w.isError = false;
            });
          });
        }

        if (totalSkus - 1 === totalEditedWeeks && uneditedIdx > -1) {
          rows[uneditedIdx].w[weekIdx].isDisabled = true;
        }

        rows.forEach(row => {
          if (this.state.selectedMeasure === 'val_quota') {
            const planValueIdx = row.w[weekIdx].rmsr.findIndex((rmsr) => rmsr.n === this.state.selectedMeasure);
            const planUnitIdx = row.w[weekIdx].rmsr.findIndex((rmsr) => rmsr.n === 'qty_quota');
            const planAspIdx = row.w[weekIdx].rmsr.findIndex((rmsr) => rmsr.n === 'plan_asp');

            row.w[weekIdx].rmsr[planValueIdx].v = row.w[weekIdx].value;
            row.w[weekIdx].rmsr[planUnitIdx].v = !!row.w[weekIdx].rmsr[planAspIdx].v
              ? Math.round(row.w[weekIdx].rmsr[planValueIdx].v / row.w[weekIdx].rmsr[planAspIdx].v)
              : 0;
            row.w[weekIdx].rmsr[planValueIdx].isC = true;
            row.w[weekIdx].rmsr[planUnitIdx].isC = true;
          } else {
            const mIdx = row.w[weekIdx].rmsr.findIndex((rmsr) => rmsr.n === this.state.selectedMeasure);
            row.w[weekIdx].rmsr[mIdx].v = row.w[weekIdx].value;
            row.w[weekIdx].rmsr[mIdx].isC = true;
          }
        });
      }
    } else {
      const rows = this.state.dataSource.rows;
      rows[rowIdx].w[weekIdx].rmsr.forEach((rmsr) => {
        if (rmsr.n === this.state.selectedMeasure) {
          rmsr.v = rows[rowIdx].w[weekIdx].value;
          rmsr.isC = true;
        }
      });
    }

    this.setState({ dataSource: this.state.dataSource });
  }

  saveData(isFreezeRequired: boolean): void {
    const payload = {
      rows: this.state.dataSource.rows
        .filter((row) => row.isEdited)
        .map((row) => {
          return {
            p: row.p.c,
            w: row.w.map((w) => {
              return {
                n: w.n,
                m: w.rmsr.filter((rmsr) => rmsr.isC)
                  .map((rmsr) => {
                    return {
                      n: rmsr.n,
                      v: rmsr.v,
                    };
                  })
              };
            }).filter((w) => w.m.length > 0)
          };
        })
    };

    const params = {
      userId: sessionStorage.getItem('userName'),
      editedMeasure: this.state.selectedMeasure,
    };

    this.props.onUpdateStart();

    SaveSKULevelWeekData(payload, params)
      .then((res) => {
        if (!!res) {
          this.setState({
            //isModalOpened: true
          }, () => {
            if (isFreezeRequired) {
              this.freezePlan();
            } else {
              this.props.onUpdateEnd();
              this.props.UpdateEditRestriction(false);
            }
          });
        }
      });
  }

  saveButtonValidity(): boolean {
    const { rows } = this.state.dataSource;

    const hasEditedRows = rows.some(row => row.isEdited);
    const noErrors = rows.every(row => row.w.every(week => !week.isError));

    return rows.length > 0 && hasEditedRows && noErrors;
  }

  saveFreezeButtonValidity(): boolean {
    const { rows } = this.state.dataSource;
    const noErrors = rows.every(row => row.w.every(week => !week.isError));

    return rows.length > 0 && grandTotal(rows, true) > 0 && noErrors;
  }

  disableActionBtn(): boolean {
    const { rows } = this.state.originalDataSource;

    if (!rows?.length || !rows[0]?.w?.length) {
      return true;
    }

    return rows[0].w.reduce((wInit, w) => wInit && w.isP, true);
  }

  render(): React.ReactNode {

    if (this.state.isAutoLoad) {
      return <InitialMessage/>;
    }

    if (this.state.isLoading) {
      return <PageLoader status={this.state.isLoading} />;
    }

    if (this.state.originalDataSource.rows.length === 0) {
      return <NoDataFound/>;
    }

    
    const renderEventInfo = (events, type: string) => (
      events.map((event, eventIdx) => (
        <React.Fragment key={eventIdx}>
          <p className="mb-1">Event Name: {event.eventName} ({type})</p>
          <p className="mb-1">Country: {event.countryCode}</p>
          <p className="mb-1">Start Date: {event.eventStartDate}</p>
          <p className="mb-0">End Date: {event.eventEndDate}</p>
          {events.length - 1 !== eventIdx && <hr className="my-2"/>}
        </React.Fragment>
      ))
    );

    return (
      <React.Fragment>

        <PageLoader
          status={this.state.isLoading}
        />

        <Card className="section-header-card">
          <Row>
            <Col md={3} className="align-self-center">
              <div className="d-flex">
                <p className="table-title">{this.props.filterData.level} -
                  <span className="sub-title"> {this.props.filterData.products}</span>
                </p>
                <img src={InfoIcon} alt="info-icon" className="cursor-pointer"/>
              </div>
            </Col>

            <Col md={3}>
              <div className="custom-form-container">
                <label htmlFor={'measure'} className="custom-form-label">Measure</label>
                <select
                  id="measure"
                  className="custom-drop-down-field custom-select-width"
                  onChange={(e) => this.setState({
                    selectedMeasure: e.target.value
                  }, () => this.dataInit())}
                >
                  {
                    measureList.map((measure, measureIdx: number) => (
                      <option
                        key={measureIdx}
                        value={measure.id}
                      >
                        {measure.value}
                      </option>
                    ))
                  }
                </select>
              </div>
            </Col>

            <Col md={4} className="align-self-center">
              <div className="custom-form-container">
                <label className="custom-form-label">Distribution mode</label>

                <div className="d-flex align-items-center me-3">
                  <Input
                    id="Fixed SKU"
                    name="Distribution mode"
                    type="radio"
                    checked={this.state.distributionMode === 'Fixed SKU'}
                    onChange={() => {
                      this.props.isAllowed
                        ? this.setState({ isEditRestrictionAllowed: true })
                        : this.setState({
                          distributionMode: 'Fixed SKU'
                        }, () => this.dataInit());
                    }}
                  />
                  <Label for="Fixed SKU" check>Fixed SKU</Label>
                </div>

                <div className="d-flex align-items-center">
                  <Input
                    id="Fixed Week"
                    name="Distribution mode"
                    type="radio"
                    checked={this.state.distributionMode === 'Fixed Week'}
                    onChange={() => {
                      this.props.isAllowed
                        ? this.setState({ isEditRestrictionAllowed: true })
                        : this.setState({
                          distributionMode: 'Fixed Week'
                        }, () => this.dataInit());
                    }}
                  />
                  <Label for="Fixed Week" check>Fixed Week</Label>
                </div>
              </div>
            </Col>

            <Col md={2} className="align-self-center text-right">
              <Dropdown
                isOpen={this.state.isVisibilityMenuOpened}
                toggle={this.toggleVisibilityMenu}
                className="d-inline-block user-dropdown px-2"
              >
                <Tooltip
                  content={'Measure Visibility Setting'}
                  direction={'top'}
                >
                  <DropdownToggle tag="button" className="btn action-btn waves-effect p-0">
                    <i className="ri-list-settings-line font-size-18"/>
                  </DropdownToggle>
                </Tooltip>

                <DropdownMenu className="custom-dropdown-menu dropdown-menu-end">
                  <React.Fragment>
                    <div className="dropdown-menu-box-sm">
                      {
                        this.state.measureVisibilityList.map((measure, mIdx: number) => (
                          <React.Fragment key={mIdx}>
                            {
                              ['product_code', 'product_description', 'measure', 'time'].indexOf(measure.id) === -1 &&
                              <DropdownItem
                                toggle={false}
                                className={`${(measure.isVisible !== measure.prevCheck) && 'dropdown-item-changed'}`}
                              >
                                <div className="d-flex align-items-center">
                                  <Input
                                    id={mIdx.toString()}
                                    type="checkbox"
                                    checked={measure.isVisible}
                                    onChange={() => this.onUpdateVisibilityCheck(mIdx)}
                                    className="me-2 flex-shrink-0"
                                  />
                                  <Label for={mIdx.toString()} className="cursor-pointer mb-0">
                                    {measure.name}
                                  </Label>
                                </div>
                              </DropdownItem>
                            }
                            {
                              this.state.measureVisibilityList.length - 1 !== mIdx &&
                              [0, 1].indexOf(mIdx) === -1 &&
                              <DropdownItem divider/>
                            }
                          </React.Fragment>
                        ))
                      }
                    </div>
                    <div className="py-1 text-right">
                      <Button
                        color={'primary'}
                        disabled={this.checkVisibilitySaveButton()}
                        className="btn btn-sm btn-primary ms-3 mx-3"
                        onClick={() => this.updateMeasureVisibility()}
                      >
                        Save
                      </Button>
                    </div>
                  </React.Fragment>
                </DropdownMenu>
              </Dropdown>

              <Dropdown
                isOpen={this.state.isMoreMenuOpened}
                toggle={this.toggleMoreMenu}
                className="d-inline-block user-dropdown"
              >
                <Tooltip content={'More'} direction={'top'}>
                  <DropdownToggle tag="button" className="btn action-btn waves-effect p-0">
                    <img src={MoreIcon} alt="more-icon"/>
                  </DropdownToggle>
                </Tooltip>

                <DropdownMenu className="dropdown-menu-end">

                  {/*<DropdownItem
                    onClick={() => this.initializeSKU()}
                  >Initialize</DropdownItem>

                  <DropdownItem divider/>*/}

                  <div className="position-relative">
                    <DropdownItem
                      disabled={this.disableActionBtn()}
                      onClick={() => {
                        if (this.props.isAllowed) {
                          this.setState({ isEditRestrictionAllowed: true });
                        }
                      }}
                    >
                      Import
                    </DropdownItem>
                    <input
                      type="file"
                      accept=".csv,
                      application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                      application/vnd.ms-excel"
                      disabled={this.disableActionBtn()}
                      onChange={(e) => {
                        this.importTemplate(e);
                        this.toggleMoreMenu();
                      }}
                    />
                  </div>

                  <DropdownItem divider/>

                  <Dropdown
                    isOpen={this.state.isDownloadMenu}
                    toggle={this.toggleDownloadMenu}
                    className="d-inline-block user-dropdown"
                    direction="end"
                  >
                    <DropdownToggle className={styles['dropdown-toggle']}>Download Template</DropdownToggle>
                    <DropdownMenu id={styles['downloadDropdown']}>
                      <DropdownItem onClick={() => this.downloadSkuLevelSalesPlan('UNIT')}>
                        Units
                      </DropdownItem>
                      <DropdownItem onClick={() => this.downloadSkuLevelSalesPlan('VALUE')}>
                        Revenue
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>

                  <DropdownItem divider/>

                  <DropdownItem
                    onClick={() => this.downloadSKULevelFreezePlan('RollingPlanSKULevelFreeze')}
                  >Download SKU Freeze Plan</DropdownItem>

                  <DropdownItem divider/>

                </DropdownMenu>

              </Dropdown>
            </Col>
          </Row>
        </Card>

        <div className={`table-responsive table-outline custom-table sticky-table ${styles['sku-level-table-container']}`}>
          <Table id="sku-level-rolling-plan-edit-all-table" className="mb-0" style={{ tableLayout: 'fixed' }}>
            <thead>
            <tr>
              {
                this.state.dataSource.columns.map((col: ISKULevelPlanningEditAllColumn, colIdx: number) => (
                  <React.Fragment key={colIdx}>
                    {
                      (col.isV && col.w.length === 0)
                        ? <th
                          data-position={col.position}
                          draggable="true"
                          onDragStart={() => this.onColumnDrag(col.position)}
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={() => this.onColumnDrop(col.position)}
                          className={`${colIdx < 2 ? styles['sticky-col'] : 'position-relative'} cursor-pointer`}
                          style={
                            Object.assign(
                              {},
                              this.addColumnWidth(colIdx, col.width || 160),
                              { cursor: 'grab' }
                            )
                          }
                        >
                          <div
                            className="dragger-line"
                            draggable={true}
                            // onDragStart={(e) => this.handleStart(e, measure.id)}
                            // onDrag={(e) => this.handleMove(e, measure.id, mIdx)}
                          />
                          <span onClick={() => this.doSort(col.n, '')}>
                            {col.dN}
                            {
                              this.state.sortKey === col.n &&
                              <span className="px-1">{this.state.sortDirection === 'asc' ? '↑' : '↓'}</span>
                            }
                          </span>
                        </th>
                        : col.w.map((w, wIdx: number) => (
                          <th
                            key={w.n + wIdx}
                            style={{ width: '120px' }}
                            onClick={() => this.doSort(col.n, w.n)}
                          >
                            <div className="d-flex justify-content-between">
                              <span>{w.n}</span>
                              {
                                ((!!w.eventInfo?.MAIN && w.eventInfo?.MAIN?.length > 0) ||
                                  (!!w.eventInfo?.Other && w.eventInfo?.Other?.length > 0)) &&
                                (
                                  <Tooltip
                                    content={
                                      <React.Fragment>
                                        {w.eventInfo?.Other && renderEventInfo(w.eventInfo.Other, 'Other')}
                                        {w.eventInfo?.MAIN && renderEventInfo(w.eventInfo.MAIN, 'Main')}
                                      </React.Fragment>
                                    }
                                    style={{ textAlign: 'left', top: '30px' }}
                                  >
                                    <i className={`mdi mdi-note cursor-pointer ${!!w.eventInfo?.MAIN && 'text-danger'}`}/>
                                  </Tooltip>
                                )
                              }
                            </div>
                            {
                              this.state.sortKey === w.n &&
                              <span className="px-1">{this.state.sortDirection === 'asc' ? '↑' : '↓'}</span>
                            }
                          </th>
                        ))
                    }
                  </React.Fragment>
                ))
              }
              <th style={{ width: '150px' }}>
                Total {this.state.distributionMode === 'Fixed SKU' ? '/ Remaining' : ''}
              </th>
            </tr>
            <tr>
              {
                this.state.dataSource.columns.map((col, colIdx: number) => (
                  <React.Fragment key={colIdx}>
                    {
                      (col.isV && col.w.length === 0)
                        ? <th
                          className={`${colIdx < 2 ? styles['sticky-col'] : 'position-relative'} cursor-pointer`}
                          style={
                            Object.assign(
                              {},
                              this.addColumnWidth(colIdx, col.width),
                              { cursor: 'grab' }
                            )
                          }
                        >
                          <input
                            type={'text'}
                            className="editable-input text-left"
                            style={{ width: '100%' }}
                            onChange={(e) => this.columnSearchHandler(colIdx, e.target.value, 'measure', -1)}
                            value={col.value}
                          />
                        </th>
                        : col.w.map((w, wIdx: number) => (
                          <th key={w.n + wIdx} style={{ width: '120px' }}>
                            <select
                              className="aggregate-select"
                              style={{ width: '25px' }}
                              onChange={(e) => this.updateAggregateSelect(colIdx, e.target.value, wIdx)}
                            >
                              <option value="=">=</option>
                              <option value="<">&lt;</option>
                              <option value=">">&gt;</option>
                              <option value="<=">≤</option>
                              <option value=">=">≥</option>
                            </select>
                            <input
                              type={'number'}
                              className="editable-input text-left w-75"
                              onChange={(e) => this.columnSearchHandler(colIdx, e.target.value, 'week', wIdx)}
                              value={col.value}
                            />
                          </th>
                        ))
                    }
                  </React.Fragment>
                ))
              }
              <th style={{ width: '100px' }}/>
            </tr>
            </thead>
            <tbody>
            {
              this.state.dataSource.rows.map((row, rIdx: number) => (
                <React.Fragment key={rIdx}>
                  <tr>
                    {
                      row.p.cmsr.map((cmsr, cmsrIdx: number) => (
                        <React.Fragment key={cmsr.n + cmsrIdx}>
                          {
                            cmsr.isV &&
                            <td
                              className={`${cmsrIdx < 2 ? styles['sticky-col'] : 'position-relative'}`}
                              style={
                                Object.assign(
                                  {},
                                  this.addColumnWidth(cmsrIdx, 160),
                                  {
                                    // whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    width: '160px'
                                  },
                                )
                              }
                            >
                              {cmsr.v}
                              {
                                cmsrIdx === 0 &&
                                <i
                                  className={`fa ${row.p.isE ? 'fa-minus' : 'fa-plus'} ms-2 cursor-pointer`}
                                  onClick={() => this.onToggleRow(rIdx, row.p?.c)}
                                />
                              }
                            </td>
                          }
                        </React.Fragment>
                      ))
                    }
                    <td>
                      {row.w[0].rmsr.find(rmsr => rmsr.n === this.state.selectedMeasure)?.dN}
                    </td>
                    {
                      row.w.map((w, wIdx: number) => (
                        <td key={w.n + wIdx} className="text-right">
                          <input
                            type={'number'}
                            className={
                              `${(w.isEdited)
                                ? 'editable-input-new'
                                : 'editable-input'}
                                  ${w.isDisabled && ' readonly-input'}
                                  ${w.isError && ' editable-error-input'}
                                  ${IsNegative(w.value) && ' error-input'}`
                            }
                            readOnly={w.isDisabled}
                            disabled={w.isP}
                            onChange={(e) => this.updateMeasureValue(rIdx, wIdx, e.target.value)}
                            value={w.value}
                            style={{ width: 60 }}
                          />
                        </td>
                      ))
                    }
                    <td className="text-right">
                      {NumberWithCommas(horizontalTotal(row, false))} {this.state.distributionMode === 'Fixed SKU'
                      ? `/ ${NumberWithCommas(remainingHorizontalTotal(row, false))}` : ''}
                    </td>
                  </tr>
                  {
                    row.p.isE &&
                    row.w[0].rmsr.map((rmsr, rmsrIdx: number) => (
                      <tr key={rmsrIdx}>
                        <td
                          className={styles['sticky-col']}
                          style={Object.assign({}, this.addColumnWidth(0, 160),)}
                        />
                        <td
                          className={styles['sticky-col']}
                          style={Object.assign({}, this.addColumnWidth(1, 160),)}
                        />
                        {
                          row.p.cmsr.filter(cmsr => cmsr.isV).length > 2 &&
                          <td colSpan={row.p.cmsr.filter(cmsr => cmsr.isV).length - 2}/>
                        }
                        <td>{rmsr.dN}</td>
                        {
                          row.w.map((w, wIdx: number) => (
                            <td key={wIdx} className="text-right">
                              {(w.rmsr[rmsrIdx]?.dT === "percentage"? OneDecimalPlace(w.rmsr[rmsrIdx]?.v ?? 0) + "%": NumberWithCommas(Math.round(w.rmsr[rmsrIdx]?.v ?? 0)))}
                            </td>
                          ))
                        }
                        <td className="text-right">
                          {
                            rmsr.n === 'qty_quota'
                              ? `${NumberWithCommas(horizontalPlanUnitTotal(row))} ${this.state.distributionMode === 'Fixed SKU'
                              ? ('/' + NumberWithCommas(remainingHorizontalPlanUnitTotal(row)))
                              : ''}`
                              : ''
                          }
                        </td>
                      </tr>
                    ))
                  }
                </React.Fragment>
              ))
            }
            {
              this.state.dataSource.rows.length > 0 &&
              <tr>
                <td
                  className={styles['sticky-col']}
                  style={Object.assign({}, this.addColumnWidth(0, 160),)}
                />
                <td
                  className={styles['sticky-col']}
                  style={Object.assign({}, this.addColumnWidth(1, 160),)}
                />
                {
                  this.state.dataSource.rows[0].p.cmsr.filter(cmsr => cmsr.isV).length > 2 &&
                  <td colSpan={this.state.dataSource.rows[0].p.cmsr.filter(cmsr => cmsr.isV).length - 2}/>
                }
                <td>Total {this.state.distributionMode === 'Fixed Week' ? '/ Remaining' : ''}</td>
                {
                  this.state.dataSource.rows[0].w.map((w, wIdx: number) => (
                    <td key={wIdx} className="text-right">
                      {NumberWithCommas(verticalTotal(this.state.dataSource.rows, wIdx, false))} {this.state.distributionMode === 'Fixed Week'
                      ? `/ ${NumberWithCommas(remainingVerticalTotal(this.state.dataSource.rows, wIdx, false))}` : ''}
                    </td>
                  ))
                }
              </tr>
            }
            </tbody>
          </Table>
        </div>

        <Row>
          <Col md={12}>
            <Pagination
              currentPage={this.state.currentPage}
              totalCount={this.state.itemsCount}
              pageSize={this.state.itemsPerPage}
              onPageChange={(page) => this.handlePageChange(page)}
            />
          </Col>
        </Row>

        <SuccessModal
          isOpen={this.state.isModalOpened}
          toggle={() => this.setState({ isModalOpened: !this.state.isModalOpened })}
          message={'Data saved successfully !!!'}
        />

        <ActionCard
          onCancel={() => this.resetCalculations()}
          onSave={() => this.saveData(false)}
          onSaveAndFreeze={() => this.saveData(true)}
          isSaveDisabled={!this.saveButtonValidity()}
          isSaveAndFreezeDisabled={!this.saveFreezeButtonValidity()}
        />

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any): StateProps => {
  return {
    ...state.EditRestriction,
    filterData: state.FilterData
  };
};

export default connect<StateProps, DispatchProps, OwnProps>
(mapStateToProps, {
  UpdateEditRestriction
})(withRouter(PlanningTable));
